import React, { useState } from 'react';
import QrScanner from 'react-qr-scanner';
import axios from 'axios';

const TeacherQRScanner = () => {
  const [teacherId, setTeacherId] = useState(null); // State to hold the scanned teacher ID
  const [attendanceStatus, setAttendanceStatus] = useState(null); // State to show success/failure message
  const [error, setError] = useState(null); // State to hold error messages
  const [isAttendanceMarked, setIsAttendanceMarked] = useState(false); // State to check if attendance is marked

  // Static teacher ID for testing
  const staticTeacherId = '66f12d8a8f27884ade9f1349'; // Replace with a valid teacher ID for testing

  // Function to handle QR code result
  const handleScan = async (data) => {
    if (data) {
      // Set the scanned teacher ID to the static one for testing
      const scannedTeacherId = staticTeacherId;

      try {
        // Check if attendance has already been marked for today
        const todayDate = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teacherAttendances/checkAttendance/${scannedTeacherId}/${todayDate}`);

        if (response.data.attendanceMarked) {
          setIsAttendanceMarked(true); // Attendance is already marked
          setAttendanceStatus(null); // Clear previous messages
          setError('Attendance has already been marked for today.');
          return;
        }
        // Prepare the data for API request
        const attendanceData = {
          date: todayDate,
          teachers: [
            {
              teacherId: scannedTeacherId,
              classIncharge: 'Maths', // Adjust this as needed
              date: todayDate,
              status: 'Present',
            },
          ],
        };

        // Make the API call to create the attendance record
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/teacherAttendances/createTeacherAttendance`, attendanceData);

        // Show success message
        setAttendanceStatus('Attendance marked as Present for today.');
        setError(null); // Clear any previous errors
      } catch (err) {
        console.error(err);
        setError('Error marking attendance. Please try again.');
        setAttendanceStatus(null); // Clear success message
      }
    }
  };

  const handleError = (err) => {
    console.error(err);
    setError('Error scanning QR code.');
  };

  const previewStyle = {
    height: 240,
    width: 320,
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold mb-4">Teacher QR Scanner</h1>
        
        <div className="w-full mb-6">
          <QrScanner
            delay={300}
            style={previewStyle}
            onError={handleError}
            onScan={handleScan}
          />
        </div>

        {/* Display the attendance status */}
        {attendanceStatus && <div className="text-green-500 font-bold">{attendanceStatus}</div>}
        {error && <div className="text-red-500 font-bold">{error}</div>}

        <div className="mt-4">
          <p>Scanned Teacher ID: {teacherId || 'No teacher scanned yet'}</p>
        </div>

        {/* Show message if attendance is already marked */}
        {isAttendanceMarked && <div className="text-red-500 font-bold">Attendance has already been marked for today.</div>}
      </div>
    </div>
  );
};

export default TeacherQRScanner;
